import { type MutableRefObject } from "react";

export type RefItem = {
  title?: string;
  ref?: MutableRefObject<HTMLDivElement | null>;
};

const scrollToSection = (title: string, refs: RefItem[]) => {
  let ref: MutableRefObject<HTMLDivElement | null> | undefined;

  refs?.map((r) => {
    switch (title) {
      case r.title:
        ref = r.ref;
        break;
    }
  });

  if (ref?.current) {
    const viewportHeight = window.innerHeight;
    const elementRect = ref.current.getBoundingClientRect();
    const elementTopToViewport = elementRect.top;
    const elementHeight = elementRect.height;
    const offset = 150;

    let topPx;

    if (elementHeight > viewportHeight - offset) {
      topPx = window.scrollY + elementTopToViewport - offset;
    } else {
      const viewportCenter = viewportHeight / 2;
      topPx =
        window.scrollY +
        elementTopToViewport -
        (viewportCenter - elementHeight / 2);
      topPx = Math.max(topPx, window.scrollY + elementTopToViewport - offset);
    }

    window.scrollTo({
      top: topPx,
      behavior: "smooth",
    });
  }
};
export default scrollToSection;
